module.exports = "/dist/montserrat-latin-600italic.svg?996d2512fdf5a4708499ebc5df282d92";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-600italic.svg
// module id = 77
// module chunks = 0